import { generateAction } from '../builder'

const getCategories = generateAction('getCategories', 'admin/categories')
const getCategory = generateAction('getCategory', 'admin/categories/{id}')

export default {
  getCategories,
  getCategory,
}
